export default "__VITE_ASSET__1309ad52__"